import React, { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';

import { history } from '../../state/configureStore';
import { resolveCommunicationAdHref } from '../../utils/communicationLink';

const CommunicationAdLink = forwardRef(({
  href,
  className,
  style,
  ariaLabel,
  tabIndex,
  children,
  onBeforeNavigate,
}, ref) => {
  const resolved = resolveCommunicationAdHref(href);

  const handleClick = useCallback((event) => {
    onBeforeNavigate?.();
    if (resolved.kind !== 'internal') {
      return;
    }
    event.preventDefault();
    history.push(resolved.to);
  }, [resolved, onBeforeNavigate]);

  if (resolved.kind === 'none') {
    return null;
  }

  const linkHref = resolved.kind === 'internal' ? resolved.to : resolved.href;

  return (
    <a
      ref={ref}
      href={linkHref}
      className={className}
      style={style}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
      onClick={handleClick}
    >
      {children}
    </a>
  );
});

CommunicationAdLink.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.shape(),
  ariaLabel: PropTypes.string,
  tabIndex: PropTypes.number,
  children: PropTypes.node,
  onBeforeNavigate: PropTypes.func,
};

CommunicationAdLink.defaultProps = {
  href: '',
  className: '',
  style: undefined,
  ariaLabel: undefined,
  tabIndex: undefined,
  children: null,
  onBeforeNavigate: undefined,
};

export default CommunicationAdLink;
